import { Container } from '@plone/components';
import Icon from '@plone/volto/components/theme/Icon/Icon';

import LinkedInSVG from 'novareto-bg-etem/icons/LinkedIn.svg';
import XingSVG from 'novareto-bg-etem/icons/Xing.svg';
import InstagramSVG from 'novareto-bg-etem/icons/Instagram.svg';
import YoutubeSVG from 'novareto-bg-etem/icons/Youtube.svg';

const Footer = () => {
  return (
    <Container className="main-footer">
      <Container className="default">
        <div className="footer-grid">
          <div className="column-left">
            <h2>Überschrift in der Größe Medium</h2>
            <p>
              Medium, doluptat. Ut as quiam, illabor soluptatur? Nam autes del
              imi, comni nectur, oditas.
            </p>
          </div>

          <div className="column-middle">
            <div className="linkedin">
              <Icon name={LinkedInSVG} size="16px" />
              <p>LinkedIn</p>
            </div>
            <div className="xing">
              <Icon name={XingSVG} size="16px" />
              <p>Xing</p>
            </div>
            <div className="instagram">
              <Icon name={InstagramSVG} size="16px" />
              <p>Instagram</p>
            </div>
            <div className="youtube">
              <Icon name={YoutubeSVG} size="16px" />
              <p>Youtube</p>
            </div>
          </div>

          <div className="column-right">
            <h2>Überschrift in der Größe Medium</h2>
            <p>
              Medium, doluptat. Ut as quiam, illabor soluptatur? Nam autes del
              imi, comni nectur, oditas.
            </p>
            <p>
              <small>Xsmall , doluptat. Ut as quiam, illabor soluptatur?</small>
            </p>
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default Footer;
